import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card'

interface AlignmentOpportunity {
  focus: string
  opportunity: string
  rolesInvolved?: string[]
}

interface AlignmentSectionProps {
  opportunities: AlignmentOpportunity[]
}

export function AlignmentSection({ opportunities }: AlignmentSectionProps) {
  if (!opportunities?.length) return null

  return (
    <Card>
      <CardHeader>
        <CardTitle>Alignment Opportunities</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {opportunities.map((opportunity, index) => (
            <Card key={index} className="h-full">
              <CardHeader>
                <CardTitle className="text-base">{opportunity.focus}</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-sm text-muted-foreground">{opportunity.opportunity}</p>
                {opportunity.rolesInvolved && opportunity.rolesInvolved.length > 0 && (
                  <div>
                    <p className="text-sm font-medium">Roles Involved</p>
                    <p className="text-sm text-muted-foreground">
                      {opportunity.rolesInvolved.join(', ')}
                    </p>
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}